// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Ml7Q","bigColWidth":"Table_bigColWidth__YtEm-","biggerColWidth":"Table_biggerColWidth__1Bgqs","row":"Table_row__1JV6T","col":"Table_col__1zbBa"};